module.exports = __webpack_public_path__ + "img/JATANEGARA.aa663a4f.png";